<template>
  <div class="money-input-component">
    <vx-input-group class="mr-2">
      <template slot="prepend">
      <div class="prepend-text new-end-date price-floor dollar-sign">
          <span>$</span>
      </div>
      </template>
      <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
        <div class="vs-con-input">
          <input
            type="text"
            class="vs-inputx vs-input--input normal hasValue money-input"
            :class="{ 'money-input-error' : !validationRes['valid']  || moneyError}"
            :placeholder="placeholder"
            v-model="value"
            @keypress="isNumber"
            @keyup="$emit('keyup-action', validationRes, $event)"
            :fieldType="field"
            name="money-input"
            :maxlength="maxLength"
          >
        </div>
      </div>
    </vx-input-group>
    <span v-if="!validationRes.valid" class="money-error">{{ validationRes.message }}</span>
  </div>
</template>

<script>
import moneyInput from '@/helpers/moneyInput.js'

export default {
  props: ['inputValue', 'placeholder', 'moneyError', 'field'],
  data () {
    return {
      fieldType: this.field || 'budget',
      value: this.inputValue
    }
  },
  computed: {
    maxLength () {
      const indexOfDot = this.value.indexOf('.')

      if (indexOfDot !== -1) {
        return 8
      } else {
        return 7
      }
    },

    validationRes () {
      return moneyInput.checkNumber(this.fieldType, this.value)
    }
  },
  methods: {
    isNumber () {
      const isNumber = moneyInput.checkChar(event.keyCode)

      if (!isNumber) {
        event.preventDefault()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .money-input-component {
    .dollar-sign {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-right: none;
      border-image: initial;
      height: 37px;
      // margin-top: 10px;
      color: inherit !important;
    }
  }

  .money-input {
    border: 1px solid rgba(0, 0, 0, 0.2);
    height: 37px;
  }

  .money-error {
    color: #eb6165;
  }

  .money-input-error {
    border: 1px solid red !important;
  }
</style>
